import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse, Value } from 'app/types-shared';
import { endpoints } from '../endpoints';
import { AdministrationMessageItem } from './types-store';

export const api = {

  loadLanguageOptions: async (): Promise<Value[]> => {
    const response = await new RemoteAdminData(endpoints.languageOptions)
      .resource<ApiResponse<Value[]>>()
      .all();

    return response.data;
  },

  loadMessage: async (messageId: number): Promise<AdministrationMessageItem> => {
    const response = await new RemoteAdminData(endpoints.message)
      .resource<ApiResponse<AdministrationMessageItem>>()
      .withId(messageId)
      .single();

    return response.data;
  },

  deleteMessage: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.message)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  },

  createMessage: async (message: AdministrationMessageItem): Promise<AdministrationMessageItem> => {

    const request = await new RemoteAdminData(endpoints.message)
      .resource<ApiResponse<AdministrationMessageItem>>()
      .create(message);

    return request.data;
  },

  saveMessage: async (messageId: number, message: AdministrationMessageItem): Promise<AdministrationMessageItem> => {

    const request = await new RemoteAdminData(endpoints.message)
      .resource<ApiResponse<AdministrationMessageItem>>()
      .withId(messageId)
      .save(message);

    return request.data;
  }
};
